import { render, staticRenderFns } from "./CreateInvoiceService.vue?vue&type=template&id=b7bb7ade"
import script from "./CreateInvoiceService.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports